import { useState, type FormEvent } from 'react';

const FORM_SUBMIT_ADDR = 'https://readdy.ai/api/form/d9tefogjm6rqefe3vjv0';

export default function ContactSection() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');

    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setStatus('success');
      setMessage('感谢您的留言，我们会尽快回复！');
      form.reset();
      return;
    }

    try {
      const formData = new FormData(form);
      const response = await fetch(FORM_SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (
        response.ok &&
        parsed &&
        parsed.code === 'OK'
      ) {
        setStatus('success');
        setMessage('感谢您的留言，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setStatus('error');
        setMessage(
          serverMsg.includes('spam') || serverMsg.includes('form data is spam')
            ? '提交失败，请稍后再试。'
            : serverMsg || '提交失败，请稍后再试。'
        );
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后再试。');
    } finally {
      if (status === 'loading') {
        // For completed transitions
      }
    }
  };

  return (
    <section aria-labelledby="contact-heading">
      <h2 id="contact-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">
        联系我们
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-background-100 rounded-lg p-6 md:p-8">
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">联系方式</h3>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-mail-line text-primary-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-800">电子邮箱</p>
                <p className="text-sm text-foreground-500">contact@wenaishequ.com</p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-wechat-line text-primary-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-800">微信公众号</p>
                <p className="text-sm text-foreground-500">文爱社区官方</p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-time-line text-primary-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-800">工作时间</p>
                <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
              </div>
            </li>
          </ul>
        </div>

        <div className="bg-background-100 rounded-lg p-6 md:p-8">
          <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">发送留言</h3>
          <form onSubmit={handleSubmit} data-readdy-form="true" noValidate>
            <div className="space-y-4">
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  姓名
                </label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  required
                  className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors duration-200"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  邮箱
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  required
                  className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors duration-200"
                  placeholder="请输入您的邮箱"
                />
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  留言内容
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors duration-200 resize-none"
                  placeholder="请输入您想说的话（最多500字）"
                ></textarea>
              </div>

              <input
                type="text"
                name="phone_alt"
                className="form-honey"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />

              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full px-6 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {status === 'loading' ? '发送中...' : '发送留言'}
              </button>

              {status === 'success' && (
                <p className="text-sm text-secondary-600 text-center">{message}</p>
              )}
              {status === 'error' && (
                <p className="text-sm text-primary-600 text-center">{message}</p>
              )}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}